'use client'

import { HomeContainer } from '@/components/common'
import { Button } from '@/components/ui/button'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useGetReviewCoolClubQuery } from '@/hooks/react-query/club/use-review-club.query'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { ReviewItem } from './review-item'

export const CoolClubReviews = () => {
  const t = useTranslations()
  const { data } = useGetReviewCoolClubQuery()

  if (!data?.length) return null

  return (
    <HomeContainer className='py-5'>
      <div>
        <Carousel
          opts={{
            align: 'start',
            duration: 50,
            slidesToScroll: 2,
            skipSnaps: true,
          }}
          className='w-full'
        >
          <CarouselContent className='ml-0 will-change-transform lg:pb-4'>
            {data?.map((item, idx) => (
              <CarouselItem className='w-full md:basis-1/4' key={idx}>
                <ReviewItem review={item} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      </div>

      <div className='mt-5 rounded-2xl bg-primary-500 px-4 py-5 lg:mt-20 lg:flex lg:items-center lg:justify-center lg:gap-5 lg:py-10'>
        <p className='font-criteria text-base font-semibold leading-6 text-light lg:text-2xl lg:leading-9'>
          {t('landing_coolclub_page.reviews.share_section.title')}
        </p>

        <Button className='mt-5 w-full lg:mt-0 lg:w-fit' variant={'white'}>
          <Image
            alt={t('landing_coolclub_page.reviews.share_section.icon_alt')}
            src='/icons/icon-share-white.svg'
            width={19}
            height={21}
            className='invert'
          />
          {t('landing_coolclub_page.reviews.share_section.button')}
        </Button>
      </div>
    </HomeContainer>
  )
}

function CarouselNavigation() {
  return (
    <div className='absolute right-10 top-2 flex items-center gap-2 lg:top-0'>
      <CarouselPrevious className='h-10 w-10' variant='black' />
      <CarouselNext className='h-10 w-10' variant='black' />
    </div>
  )
}
